﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AstraController = void 0;
const AppControllerBase_1 = require("./AppControllerBase");
class AstraController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this._vehiclesTypes = new Map();
        this._rateAreas = new Map();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.refreshVehiclesType();
            yield this.refreshRateAreas();
        });
    }
    getVehiclesType(vehiclesTypeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const clearId = parseInt(vehiclesTypeId.toString());
            const vt = this._vehiclesTypes.get(clearId);
            if (!vt)
                yield this.refreshRateAreas();
            return this._vehiclesTypes.get(clearId);
        });
    }
    getVehiclesTypes() {
        return __awaiter(this, void 0, void 0, function* () {
            return Array.from(this._vehiclesTypes.values());
        });
    }
    refreshVehiclesType() {
        return __awaiter(this, void 0, void 0, function* () {
            var vehicleTypes = yield this.app.gui.lockAction(this.app.api.admin.directory.getAllVehicleTypes());
            if (!vehicleTypes)
                return;
            for (const vt of vehicleTypes)
                this._vehiclesTypes.set(vt.id, vt);
            return vehicleTypes;
        });
    }
    getRateArea(rateAreaId) {
        return __awaiter(this, void 0, void 0, function* () {
            const clearId = parseInt(rateAreaId.toString());
            const area = this._rateAreas.get(clearId);
            if (!area)
                yield this.refreshRateAreas();
            return this._rateAreas.get(clearId);
        });
    }
    getRateAreas() {
        return __awaiter(this, void 0, void 0, function* () {
            return Array.from(this._rateAreas.values());
        });
    }
    refreshRateAreas() {
        return __awaiter(this, void 0, void 0, function* () {
            var rateAreas = yield this.app.gui.lockAction(this.app.api.admin.directory.getAllRateAreas());
            if (!rateAreas)
                return;
            for (const area of rateAreas)
                this._rateAreas.set(area.id, area);
            return rateAreas;
        });
    }
}
exports.AstraController = AstraController;
//# sourceMappingURL=AstraController.js.map